"use client";

import * as React from "react";
import { Moon, Sun, MoonStar } from "lucide-react";
import { cn } from "@/lib/utils/utils";
import { useOrkestriaTheme, type OrkestriaTheme } from "@/lib/theme";

/**
 * Theme switcher para /docs. Conectado al `ThemeProvider` global, así que
 * cualquier componente descendiente (FakiMark, badges, etc.) reacciona en
 * vivo al cambio de tema. Sigue compatible con el dashboard porque
 * `ThemeProvider` persiste en localStorage y escucha eventos `storage`.
 */
export function DocsThemeSwitcher() {
  const { theme, setTheme } = useOrkestriaTheme();

  const options: { id: OrkestriaTheme; label: string; icon: React.ElementType }[] = [
    { id: "light", label: "Claro", icon: Sun },
    { id: "dark", label: "Azul oscuro", icon: Moon },
    { id: "night", label: "Noche", icon: MoonStar },
  ];

  return (
    <div
      role="radiogroup"
      aria-label="Tema"
      className="inline-flex items-center gap-0.5 rounded-md border border-[var(--border)] bg-[var(--card)] p-0.5"
    >
      {options.map((o) => {
        const Icon = o.icon;
        const active = theme === o.id;
        return (
          <button
            key={o.id}
            type="button"
            role="radio"
            aria-checked={active}
            title={o.label}
            onClick={() => setTheme(o.id)}
            className={cn(
              "inline-flex h-7 w-7 cursor-pointer items-center justify-center rounded transition-colors",
              active
                ? "bg-[var(--primary)]/10 text-[var(--primary)]"
                : "text-[var(--muted-foreground)] hover:text-[var(--foreground)]",
            )}
          >
            <Icon className="h-3.5 w-3.5" />
          </button>
        );
      })}
    </div>
  );
}
